<template>
  <b-container fluid>
    <div class="c-dashboard">
      <b-row class="c-dashboard__row" v-if="!isCertificateAvailable">
        <div class="col-12 c-dashboard__col">
          <get-started></get-started>
        </div>
      </b-row>
      <b-row v-else>
        <b-col md="6" class="c-dashboard__col">
          <certificates-by-public-key-algorithm-chart :statistics="statistics"></certificates-by-public-key-algorithm-chart>
        </b-col>
        <b-col md="6" class="c-dashboard__col">
          <certificates-by-signature-algorithm-chart :statistics="statistics"></certificates-by-signature-algorithm-chart>
        </b-col>
        <b-col md="6" class="c-dashboard__col">
          <top-expiring-certificates></top-expiring-certificates>
        </b-col>
        <b-col md="6" class="c-dashboard__col">
          <certificates-by-status-chart :statistics="statistics"></certificates-by-status-chart>
        </b-col>
        <b-col md="6" class="c-dashboard__col">
          <certificates-by-usage-type-chart :statistics="statistics"></certificates-by-usage-type-chart>
        </b-col>
        <b-col md="6" class="c-dashboard__col">
          <issued-certificates-chart :statistics="statistics"></issued-certificates-chart>
        </b-col>
        <b-col cols="12" class="c-dashboard__col">
          <view-latest-audits-for-user></view-latest-audits-for-user>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>
<script>
import TopExpiringCertificates from "../components/dashboard/TopExpiringCertificates";
import CertificatesByStatusChart from "../components/dashboard/CertificatesByStatusChart";
import GetStarted from "../components/dashboard/GetStarted";
import ViewLatestAuditsForUser from "../components/dashboard/ViewLatestAuditsForUser";
import IssuedCertificatesChart from "../components/dashboard/IssuedCertificatesChart";
import CertificatesByUsageTypeChart from "../components/dashboard/CertificatesByUsageTypeChart";
import CertificatesBySignatureAlgorithmChart from "../components/dashboard/CertificatesBySignatureAlgorithmChart";
import CertificatesByPublicKeyAlgorithmChart from "../components/dashboard/CertificatesByPublicKeyAlgorithmChart";

export default {
  name: "DashboardView",
  components: {
    CertificatesByUsageTypeChart,
    CertificatesByStatusChart,
    CertificatesByPublicKeyAlgorithmChart,
    CertificatesBySignatureAlgorithmChart,
    IssuedCertificatesChart,
    ViewLatestAuditsForUser,
    TopExpiringCertificates,
    GetStarted
  },
  data() {
    return {};
  },
  computed: {
    statistics() {
      return this.$store.getters["certificate/certificateStatistics"];
    },
    isCertificateAvailable() {
      var certificates = this.$store.getters["certificate/certificateStatistics"];
      if (!certificates || !certificates.data) {
        return false;
      }
      return certificates.data.certStatus.ACTIVE > 0 || certificates.data.certStatus.REVOKED > 0 || certificates.data.certStatus.EXPIRED > 0;
    }
  },
  mounted() {
    this.$store.dispatch("certificate/getCertificateStatisticsForUser");
  }
};
</script>
<style scoped></style>
